var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({class:_vm.computedClass,attrs:{"block":_vm.block,"small":_vm.small,"elevation":"0","disabled":_vm.disabled}},'v-btn',_vm.filteredAttrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }